import './index.scss';

import {
  UnauthenticatedTemplate,
  useMsal,
  useIsAuthenticated,
} from '@azure/msal-react';
import { loginRequest } from '../../auth-config';
import { Box, Typography, Button } from '@mui/material';
import { useLoginHelper } from './LoginCallBack';
import {
  CUSTOM_EVENTS,
  appLogEvent,
} from '../../utils/analytics';
// import { useAuthHelper } from '../../utils/functions/authentication';
import { useEffect } from 'react';
import React from 'react';

export const OktaSignIn: React.FC = () => {
  const ProfileContent = () => {
    const { instance, accounts } = useMsal();

    const isAuthenticated = useIsAuthenticated();
    const handleRedirect = () => {
      appLogEvent(CUSTOM_EVENTS.SSO_SIGN_IN);
      localStorage.setItem('isMSALUser', 'true');
      instance
        .loginRedirect(loginRequest)

        .catch((error) => console.log(error));
    };
    const userValidation = useLoginHelper();
    const tokenExpired = () => {
      const storedToken = localStorage.getItem('authToken');
      if (storedToken) {
        const decodedToken = JSON.parse(
          atob(storedToken.split('.')[1])
        );
        return decodedToken.exp * 1000 < Date.now();
      }
      return true;
    };

    useEffect(() => {
      if (isAuthenticated) {
        if (accounts.length > 0 && !tokenExpired()) {
          window.location.reload();
        }
      }
    }, [isAuthenticated, accounts, tokenExpired()]);

    return (
      <div className="flex justify-center">
        {userValidation?.responseStatus?.status ===
          'NOT_FOUND' && (
          <div className="user_not_found_text">
            You currently do not have access to this
            application. Please reach out to{' '}
            <span className="font-bold">
              Vishnu Kaura (vishnu@nurture.farm)
            </span>{' '}
            if you need access.
          </div>
        )}
        <UnauthenticatedTemplate>
          <Box className="login-box">
            <Box className="inner-container">
              <Box>
                <Typography className="welcome-typography">
                  <Box className="login-main-container">
                    <Box component={'span'}>
                      Advanta Farm{' '}
                    </Box>
                    <Box
                      component={'span'}
                      className="logo-text-color">
                      Analytics
                    </Box>
                  </Box>
                </Typography>
              </Box>
              <Button
                className="login"
                variant="contained"
                onClick={handleRedirect}
                fullWidth>
                Login
              </Button>
              {/* <Box>
                <Typography className="only-nurture-typography">
                  * This is only for nurture employees
                </Typography>
              </Box> */}
            </Box>
          </Box>
        </UnauthenticatedTemplate>
      </div>
    );
  };
  const MainContent = () => {
    return (
      <div className="App">
        <ProfileContent />
      </div>
    );
  };

  return <MainContent />;
};
